var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrintSign(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6428 14.9997H17C17.2762 14.9997 17.5 14.7758 17.5 14.4997V9.16634C17.5 7.32539 16.0076 5.83301 14.1667 5.83301H5.83333C3.99238 5.83301 2.5 7.32539 2.5 9.16634V14.4997C2.5 14.7758 2.72386 14.9997 3 14.9997H5.35714",
    stroke: "#fff",
    strokeWidth: 1.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.6665 5.83333V3C6.6665 2.72386 6.89036 2.5 7.1665 2.5H12.8332C13.1093 2.5 13.3332 2.72386 13.3332 3V5.83333",
    stroke: "#fff",
    strokeWidth: 1.2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.08129 16.9296L5.3569 15.0003L5.77177 12.0962C5.80696 11.85 6.01792 11.667 6.26674 11.667H13.7328C13.9816 11.667 14.1925 11.85 14.2278 12.0962L14.6426 15.0003L14.9182 16.9296C14.9613 17.2308 14.7275 17.5003 14.4233 17.5003H5.57627C5.27199 17.5003 5.03826 17.2308 5.08129 16.9296Z",
    stroke: "#fff",
    strokeWidth: 1.2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1665 8.34129L14.1748 8.33203",
    stroke: "#fff",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrintSign);
export default __webpack_public_path__ + "static/media/Print_Sign.5bafffead6cd2cc948ccf9cecc8235da.svg";
export { ForwardRef as ReactComponent };